import { render } from "./StuffFormSidebar.vue?vue&type=template&id=0ff646ef"
import script from "./StuffFormSidebar.vue?vue&type=script&lang=js"
export * from "./StuffFormSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__